import React, { useEffect, useState, useContext} from "react";
import { LanguageContext } from "../context/LanguageContext"
import  Header  from "../components/header"
import { useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"; // Estilos del DatePicker
import axios from "axios";
import { Bar } from "react-chartjs-2"
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { isSameMinute } from "date-fns";
import { handlePrint, handleDownloadCSV } from "../components/dataExport";
import { color } from "chart.js/helpers";


import { useNavigate } from "react-router-dom";

// Registra los componentes necesarios
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function Operations() {
    const { t } = useContext(LanguageContext); // 👈 Usa el hook para traer traducciones

    const { machineId } = useParams();
    const[operations, setOperations] = useState([])
    const [dateRange, setDateRange] = useState([null, null]); // Rango de fechas
    const [startDate, endDate] = dateRange; // Destructura las fechas
    const [hourlyAverages, setHourlyAverages] = useState([]); //Para grafico promedio operaciones / hr

    const handleDateChange = (update) => {
        console.log("Fechas seleccionadas:", update); // Muestra las fechas seleccionadas
        setDateRange(update);
    };
    //Compny Logo -----------------------
    const company = JSON.parse(localStorage.getItem("company"));


    // Para Actividades / hora

//V2
const fetchOperations = async () => {
    if (!machineId) {
        console.error("❌ machineId no está definido");
        return;
    }

    const company = JSON.parse(localStorage.getItem("company")); // ✅ Obtener `id_c` de localStorage
    if (!company || !company.id_c) {
        console.error("❌ No se encontró id_c en la empresa");
        return;
    }

    try {
        console.log("📌 Ejecutando fetchOperations con parámetros:", { machineId, startDate, endDate, id_c: company.id_c });

        const baseUrl = window.location.hostname === "localhost" 
            ? "http://localhost:5000" 
            : "https://mi-api-695949786110.us-central1.run.app";

        const response = await axios.get(`${baseUrl}/company/${company.id_c}/operations/${machineId}`, { 
            params: {
                id_c: company.id_c, // ✅ Ahora envía el ID de la empresa
                startDate: startDate ? startDate.toISOString().split("T")[0] : null,
                endDate: endDate ? endDate.toISOString().split("T")[0] : null,
            },
        });

        console.log("✅ Datos recibidos del backend:", response.data);

        if (response.data.length > 0) {
            setOperations(response.data);
        } else {
            console.warn("⚠️ La API devolvió un array vacío.");
            setOperations([]);
        }
    } catch (error) {
        console.error("❌ Error fetching operations:", error.response ? error.response.data : error);
    }
};

const handleApplyFilter = () => {
    console.log("Aplicando filtro con fechas:", { startDate, endDate });
    fetchOperations(); // Consulta Total Registros
    fetchHourlyAverages();// Consulta Promedio operaciones / hora
};


//v2
const fetchHourlyAverages = async () => {
    if (!machineId) {
        console.error("❌ machineId no está definido");
        return;
    }

    const company = JSON.parse(localStorage.getItem("company")); // ✅ Obtener `id_c` de localStorage
    if (!company || !company.id_c) {
        console.error("❌ No se encontró id_c en la empresa");
        return;
    }

    try {
        console.log("📌 Ejecutando fetchHourlyAverages con parámetros:", { machineId, startDate, endDate, id_c: company.id_c });

        const baseUrl = window.location.hostname === "localhost" 
        ? "http://localhost:5000" 
        : "https://mi-api-695949786110.us-central1.run.app";

        const response = await axios.get(`${baseUrl}/company/${company.id_c}/average-per-hour/${machineId}`, {  
            params: {
                startDate: startDate ? startDate.toISOString().split("T")[0] : null,
                endDate: endDate ? endDate.toISOString().split("T")[0] : null,
            },
        });

        console.log("✅ Datos recibidos para promedio por hora:", response.data);

        if (response.data.length > 0) {
            setHourlyAverages(response.data);
        } else {
            console.warn("⚠️ La API devolvió un array vacío.");
            setHourlyAverages([]);
        }
    } catch (error) {
        console.error("❌ Error fetching hourly averages:", error.response ? error.response.data : error);
    }
};




// Chart Configuration

const chartData = {
    
    labels: operations.map((item) => item.fecha.slice(0, 10)), // Formatear las fechas para el gráfico
    
    datasets: [
        {
            label: "Actividades Total / Día",
            data: operations.map((item) => item.actividad), // Valores de actividad
            backgroundColor: "rgba(95, 232, 54, 0.6)", // Color de barras
            borderColor: "rgba(0, 0, 0, 0.6)",
            borderWidth: 0,
            maxBarThickness: 10,
        },
    ],
};


const chartData2 = {
    labels: hourlyAverages.map((item) => {
        const fechaFormateada = item.fecha.slice(0, 10); // "2025-04-30"
        return `${fechaFormateada} - ${item.hora}:00`;
    }),
    datasets: [
        {
            label: "Promedio de Actividades por Hora",
            data: hourlyAverages.map((item) => item.promedio_horas),
            backgroundColor: "rgba(16, 159, 248, 0.85)",
            borderColor: "rgb(0, 0, 0)",
            borderWidth: 0,
            maxBarThickness: 30,
        },
    ],
};

console.log("Chart Data:", chartData)

const chartOptions = {
    responsive: true,
    plugins: {
        legend: {
            position: "top",
            labels: {
                color: "rgb(178, 178, 178)", // Cambia el color del texto de la leyenda (nombres de datasets)

            },
        },
        /*title: {
            display: true,
            text: `Actividad Total por Fecha para Máquina ${machineId}`,
            color: "rgb(178, 178, 178)",
        },
        */
        tooltip: {
            backgroundColor: "rgb(60, 60, 60)", // Asegura que el tooltip también tenga fondo color ..
        },
    },
    layout: {
        backgroundColor: "white", // Esto no afecta directamente, pero en algunas versiones podría ayudar
    },
    scales: {
        x: {
            categoryPercentage: 1.0,
            barPercentage: 0.8,
            ticks: {
                font: {
                    size: 10,

                },
                padding: 2,
                color: "rgb(178, 178, 178)"
            },
        },
        y: {
            beginAtZero: true,
            ticks: {
                font: {
                    size: 10,
                    stepSize: 13,
                    
                    
                },
                color: "rgb(178, 178, 178)",
            },
        },
    },

}



console.log("operations: ",operations)
return (
    <>

        <div class="body">
        <Header/>

        <h2> {t('oper1')}  {machineId} {t('oper2')}</h2>

         {/* Selector de rango de fechas */}
         <div>
                    <label className="text2">{t('oper3')}</label>
                    <DatePicker className="dateSpace"
                    selectsRange
                    startDate={startDate}
                    endDate={endDate}
                    onChange={(update) => setDateRange(update)} // Actualiza las fechas seleccionadas
                    isClearable
                    placeholderText= {t('oper3')}
                    dateFormat="dd/MM/yyyy"
                />

                            {/* Botón para Aplicar Filtro */}
            <button className="button4" onClick={handleApplyFilter} style={{ marginTop: "10px" }}>
            {t('oper4')}
            </button>
                </div>

                <hr></hr>

        <table class="chart1">
                <tr>
                    <td class= "bar">
                           <Bar  data={chartData} options={chartOptions} />
                    </td>
                    <td class= "bar">
                            <Bar  data={chartData2} options={chartOptions} />
                    </td>
                </tr>
        </table>   
        <br></br>

        <hr/>

            <div>
            <h2> {t('oper5')}</h2>
                <table class="table1">  {/* Tabla Conteo Registros */}
                    <thead>
                        <tr>

                            <th> {t('oper5')}</th>
                            <th> {t('oper6')}</th>
                            <th> {t('oper7')}</th>

                        </tr>
                    </thead>
                    <tbody>
                        {operations.map((operation, index) => (
                                    <tr key={`${operation.cod_maq}-${operation.createdTS}-${index}`}>
                                        <td>{operation.cod_maq}</td>
                                        <td>{operation.actividad}</td>
                                        <td>{operation.fecha.slice(0, 10)}</td>                                    
                                    </tr>
                                ))}
                    </tbody>
                </table>
            </div>
            <button
                onClick={() => {
                    console.log("Descargando actividades:", operations);
                    handleDownloadCSV([...operations], "activities_report");
                }}> {t('oper9')}
            </button>
<hr/>

            <div>
            <h2>{t('oper10')}</h2>
                <table class="table1">
                    <thead>
                        <tr>
                            <th>{t('oper7')}</th>
                            <th>{t('oper10')}</th>
                            <th>{t('oper11')}</th>
                            <th>{t('oper12')}</th>
                            <th>{t('oper13')}</th>
                            <th>{t('oper14')}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hourlyAverages.map((item, index) => (
                            <tr key={index}>
                                <td>{item.fecha.slice(0, 10)}</td>
                                <td>{item.hora}:00</td>
                                <td>
                                    {item.primer_reg ? item.primer_reg : "No data"}
                                </td>
                                <td>
                                    {item.ultimo_reg ? item.ultimo_reg : "No data"}
                                </td>
                                <td>{item.total_registros}</td>
                                <td>
  {!isNaN(parseFloat(item.promedio_horas)) 
    ? parseFloat(item.promedio_horas).toFixed(2) 
    : "N/A"}
</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>


        <button
            onClick={() => {
            console.log("Descargando promedios:", hourlyAverages);
            handleDownloadCSV([...hourlyAverages],"averages_report", machineId);
             }}>{t('oper8')}
        </button>
             
        <hr/>
        <button onClick={handlePrint}>{t('oper15')}</button>

        </div>  


        






    </>
);
}
export default Operations;